export const SIZES = { small: "small", medium: "medium", large: "large" };
export const CSV_FILE_SIZE_IN_KB = 32;
export const ONE_KILOBYTE_IN_BYTES = 1024;
export const DOWNLOAD_SAMPLE_EMAIL_CSV_FILE =
  "https://d2v7kzglnr2dnh.cloudfront.net/others/sample-bulk-email.csv";
